jQuery(document).ready(function($) {
	if( isBreakpoint('xs') ){
		jQuery('.navbar-toggle').on('click', function(e){
			e.preventDefault();
			var $this = jQuery(this);

			$this.toggleClass('collapsed');
			$this.toggleClass('not-collapsed');

			if( $this.data('toggle')=='slide-collapse' ){
				var target = jQuery( $this.data('target') );
				
				if( target.hasClass('in') ){
					jQuery.scrollLock( false );
					target.removeClass('in');
					target.animate({
						right: '-100%'
					});
				}
				else{
					jQuery.scrollLock( true );
					var newHeight = jQuery(window).height() - jQuery('.navbar-header').height() - parseInt(target.css('paddingBottom'));
					var newWidth = (jQuery(window).width() * 0.65) + 40;
					target.addClass('in');
					target.animate({
						right: '-' + (jQuery(window).width() - newWidth - 40)
					});

					target.width( newWidth );
					target.height( newHeight );
					target.find('.primary-nav').height( newHeight );
				}
			}
		});
	}

	jQuery('.search-toggle').on('click', function(e){
		e.preventDefault();

		if( isBreakpoint('xs') || isBreakpoint('sm') || isBreakpoint('md') ){
			var searchBox = jQuery('.navbar-search');

			jQuery('.navbar-default').removeClass('nav-up').addClass('nav-down');

			if( searchBox.hasClass('open') ){
				searchBox.slideUp().removeClass('open');
			}
			else{
				searchBox.slideDown().addClass('open');
				searchBox.find('input.form-control').focus();
			}
		}
		else{
			var searchBox = jQuery('.desktop-navbar > .navbar-form');

			if( searchBox.hasClass('open') ){
				if( searchBox.find('.form-control').val()=='' ){
					searchBox.removeClass('open');
				}
				else{
					searchBox.find('.search-submit').click();
				}
			}
			else{
				searchBox.addClass('open');
				searchBox.find('.form-control').focus();
			}
		}
	});

	$(window).on('click scroll', function() {
		jQuery('.inpage-products').removeClass('open');
		$('.inpage-products .subcats-list').css({
			position: 'fixed',
			//top: 0,
			minHeight: 0,
			maxHeight: 0
		}).addClass('no-height');
	});
	jQuery('.subcats-list, .inpage-products .cats-list a, .navbar-fixed-products').click(function(event){
	    event.stopPropagation();
	});

	jQuery('.inpage-products .cats-list').clone().appendTo('.inpage-products .subcats-list .cats-list2');
	jQuery('.inpage-products .cats-list a').on('click', function(e){
		if( $(this).data('target') ){
			e.preventDefault();

			jQuery('.inpage-products .cats-list li.jsactive').removeClass('jsactive');
			$(this).parent().addClass('jsactive');

			jQuery('.inpage-products .subcats-list .cats-list > ul > li').eq( $(this).parent().index() ).addClass('jsactive');

			jQuery('.inpage-products .subcats-list .list > .row').hide();
			jQuery('.inpage-products .subcats-list ' + $(this).data('target')).show();

			jQuery('.inpage-products').addClass('open');
			jQuery('.inpage-products .subcats-list').removeClass('no-height').css({
				minHeight: jQuery('.inpage-products .cats-list').outerHeight(),
				maxHeight: 'auto',
				position: 'fixed',
				top: jQuery('.inpage-products .cats-list').offset().top,
			});
		}
	});

	$('.navbar-fixed-products').click(function(e){
		e.preventDefault();

		if( !$(this).hasClass('open') ){
			$(this).addClass('open');

			jQuery('.inpage-products').addClass('open');
			jQuery('.inpage-products .subcats-list').removeClass('no-height').css({
				position: 'fixed',
				top: jQuery('.navbar-default').height(),
				maxHeight: 'auto',
				minHeight: jQuery('.inpage-products .cats-list').outerHeight()
			});
		}
		else{
			$(this).removeClass('open');

			jQuery('.inpage-products .cats-list li.jsactive').removeClass('jsactive');
			jQuery('.inpage-products .subcats-list .list > .row').hide();

			jQuery('.inpage-products').removeClass('open');
			$('.inpage-products .subcats-list').css({
				position: 'fixed',
				//top: 0,
				maxHeight: 0,
				minHeight: 0
			}).addClass('no-height');
		}
	});

	$('.modal').on('show.bs.modal', function () {
	});

	$('*[data-toggle="close_open_modal"]').click(function(e){
		e.preventDefault();

		var $this = $(this);

		if( $('.modal:visible').length>0 ){
			$( '#' + $('.modal:visible').attr('id') ).modal('hide');
		}
		setTimeout(function(){
			$( $this.data('target') ).modal('show');
		}, 500);
	});
});
